import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Errors, Control} from 'react-redux-form';
import {FormGroup, ControlLabel, Grid, Row, Col, Checkbox} from 'react-bootstrap';

import Editor from './editor';
import './styles.css'

class EmailMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: false,
    };

  }

  setEmail = () => {
    this.setState({
      email: !this.state.email
    })
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox model='.email'
                                onChange={this.setEmail}
                                component={Checkbox} >
                Email
              </Control.checkbox>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Subject*</ControlLabel>
              <Control.text
                model=".email_subject"
                className="form-control"/>
              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model=".email_subject"/>
            </FormGroup>

            {this.props.fetched && <Editor content={this.props.emailBody}
                  field="deep.admin_notification_edit.email_body"/>}

          </Col>
        </Row>
      </Grid>

    );

  }
}

const mapStateToProps = (state) => {
  return {
    emailBody: state.deep.admin_notification_edit.email_body,
    fetched: state.notifications.fetched,
    fetching: state.notifications.fetching,
  };
};


export default connect(mapStateToProps)(EmailMessage);


// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/email-message-editor.jsx